import axios from 'axios'
var dev = 'http://netapi.jrechina.com';
// var dev = 'http://192.168.1.38'
function getParams(data) {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  return ret
}
export function post(url, params,actionParams, success, err) {
  // if(!localStorage.getItem('JRE_MESSAGE')){
  //   this.$router.push({path:'/'});
  //   return
  // }
  let local = JSON.parse(localStorage.getItem('JRE_MESSAGE'))||{};
  let id = local.TOKEN;
  params.Owner_ID = id;
  // 请求时的拦截
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
//   axios.interceptors.request.use(function(config) {
//     if(token != null ){//有token 把头传过去
//       config.headers.s_company_token = get_Token();
//       config.headers.token = get_TokenML();
//       config.headers.erpCompanyId = (get_Userinfo() == null) ? '' : get_Userinfo().companyId;
//     }
//     return config;
//   }, function(error) {
//     return Promise.reject(error);
//   });
params = getParams(params);
  url = url + '?Action=' + actionParams.Action; 
  axios.post(dev + url, params)
    .then(function(res) {
      res = res.data;
      switch(res.Status)
      {
        case 1:
             success(res.DataList || res.Msg || '成功！');
        case 0:
          err(res.Msg);
          break;
      }
    })
    .catch(function(error) {
      // err('网络错误，数据无法加载，请稍后重试！');
      // console.log(error)
    });
}
export function get(url, params = {}, success, err) {
  // if(!localStorage.getItem('JRE_MESSAGE')){
  //   this.$router.push({path:'/'});
  //   return
  // }
  let local = JSON.parse(localStorage.getItem('JRE_MESSAGE'))||{};
  let id = local.TOKEN;
  params.Owner_ID = id;
  axios.get(dev + url, {params:params})
        .then(function(res) {
            res = res.data;
            switch(res.Status)
            {
            case 1:
                success(res.DataList || res.msgg || res.DataCount);
                break;
            case 0:
                err(res.Msg);
                break;
            }
        })
        .catch(function(error) {
            console.error(error);
            err('网络错误，数据无法加载，请稍后重试！');
        });
}
export function imgPost(url, params, actionParams,success, err) {
  // 请求时的拦截
  axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
  let str = '';
  _.forEach(actionParams , (value,key) => {
    if(str){
      str = str + '&' + key + '=' + value;
    }else{
      str = '?' + key + '=' + value
    }
  });
  url = url + str; 
  axios.post(url, params)
    .then(function(res) {
      res = res.data;
      switch(res.Status)
      {
        case 1:
             success(res.DataList || res.Msg || '成功！');
        case 0:
          err(res.Msg);
          break;
        case 2:
          err(res.Msg);
          break;
      }
    })
    .catch(function(error) {
      console.log(error);
      // err('网络错误，数据无法加载，请稍后重试！');
    });
}
export function getCharts(url, params = {}, success, err) {
  // if(!localStorage.getItem('JRE_MESSAGE')){
  //   this.$router.push({path:'/'});
  //   return
  // }
  let local = JSON.parse(localStorage.getItem('JRE_MESSAGE'))||{};
  let id = local.TOKEN;
  params.Owner_ID = id;
  axios.get(dev + url, {params:params})
        .then(function(res) {
            res = res.data;
            switch(res.Status)
            {
            case 1:
                success(res);
                break;
            case 0:
                err(res.Msg);
                break;
            }
        })
        .catch(function(error) {
            console.error(error);
            err('网络错误，数据无法加载，请稍后重试！');
        });
}



// WEBPACK FOOTER //
// ./src/util/axios.js